// extracted by mini-css-extract-plugin
export var buttons = "features-module--buttons--8ce84";
export var cardContainer = "features-module--cardContainer--d0a18";
export var dark = "features-module--dark--ff7af";
export var feature = "features-module--feature--e7e2b";
export var featureCard = "features-module--featureCard--d9ce4";
export var featureCardWrapper = "features-module--featureCardWrapper--a5d89";
export var featuresWrapper = "features-module--featuresWrapper--e4e6d";
export var headline = "features-module--headline--69801";
export var innerGrid = "features-module--innerGrid--141df";
export var light = "features-module--light--1a00b";